<template>
  <p :style="style">
    <span style="padding-right: 10px">
      <svg
        class="icon"
        width="20"
        height="13"
        viewBox="0 0 27 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.0750001 17V0.649999H5.225C6.125 0.649999 6.95833 0.733332 7.725 0.899999C8.50833 1.06667 9.18333 1.35 9.75 1.75C10.3167 2.15 10.7583 2.675 11.075 3.325C11.3917 3.95833 11.55 4.75 11.55 5.7C11.55 6.6 11.3917 7.38333 11.075 8.05C10.7583 8.71667 10.3167 9.275 9.75 9.725C9.2 10.1583 8.54167 10.4833 7.775 10.7C7.025 10.9 6.20833 11 5.325 11H2.975V17H0.0750001ZM2.975 8.675H5.1C7.5 8.675 8.7 7.68333 8.7 5.7C8.7 4.66667 8.38333 3.95833 7.75 3.575C7.13333 3.175 6.21667 2.975 5 2.975H2.975V8.675ZM14.6258 17V0.649999H19.7758C20.6758 0.649999 21.5091 0.733332 22.2758 0.899999C23.0591 1.06667 23.7341 1.35 24.3008 1.75C24.8674 2.15 25.3091 2.675 25.6258 3.325C25.9424 3.95833 26.1008 4.75 26.1008 5.7C26.1008 6.6 25.9424 7.38333 25.6258 8.05C25.3091 8.71667 24.8674 9.275 24.3008 9.725C23.7508 10.1583 23.0924 10.4833 22.3258 10.7C21.5758 10.9 20.7591 11 19.8758 11H17.5258V17H14.6258ZM17.5258 8.675H19.6508C22.0508 8.675 23.2508 7.68333 23.2508 5.7C23.2508 4.66667 22.9341 3.95833 22.3008 3.575C21.6841 3.175 20.7674 2.975 19.5508 2.975H17.5258V8.675Z"
          fill="#262626"
        />
      </svg>
    </span>
    {{ getText() }}
  </p>
</template>

<script>
export default {
  name: 'BovineChildBirth',
  props: {
    bovine: {
      type: Object,
      required: true,
    },
    inactive: Boolean,
  },
  computed: {
    style() {
      return {
        width: 'fit-content',
        heigth: '10px',
        color: 'black',
        textAlign: 'center',
        borderRadius: '3px',
        padding: '3px 8px',
        background: '#fff7ad',
        ...(this.inactive ? { background: '#dee2e6' } : {}),
      };
    },
  },
  methods: {
    getText() {
      if (!this.bovine.childBirth) {
        return '-';
      }
      const date = this.$dayjs(this.bovine.childBirth).format('DD/MM/YYYY');
      const days = this.$dayjs(this.bovine.childBirth).diff(this.$dayjs(), 'd');
      if (days < 0) {
        return '-';
      }
      if (days === 0) {
        return date;
      }
      const dayText = Math.abs(days) > 0 ? 'dias' : 'dia';
      return `${date} (${days} ${dayText})`;
    },
  },
};
</script>

<style scoped>
.icon {
  padding-top: 1px;
}
</style>
